import deckpro1 from '@/assets/deckpro (1).jpeg';
import deckpro2 from '@/assets/deckpro (2).jpeg';
import deckpro3 from '@/assets/deckpro (3).jpeg';
import deckpro4 from '@/assets/deckpro (4).jpeg';
import deckpro5 from '@/assets/deckpro (5).jpeg';
import deckpro6 from '@/assets/deckpro (6).jpeg';
import deckpro7 from '@/assets/deckpro (7).jpeg';
import deckpro8 from '@/assets/deckpro (8).jpeg';
import deckpro9 from '@/assets/deckpro (9).jpeg';
import deckpro10 from '@/assets/deckpro (10).jpeg';
import deckpro11 from '@/assets/deckpro (11).jpeg';
import deckpro12 from '@/assets/deckpro (12).jpeg';
import deckpro13 from '@/assets/deckpro (13).jpeg';
import deckpro14 from '@/assets/deckpro (14).jpeg';
import deckpro15 from '@/assets/deckpro (15).jpeg';
import deckpro16 from '@/assets/deckpro (16).jpeg';
import deckpro17 from '@/assets/deckpro (17).jpeg';
import deckpro18 from '@/assets/deckpro (18).jpeg';
import deckpro19 from '@/assets/deckpro (19).jpeg';
import deckpro20 from '@/assets/deckpro (20).jpeg';
import deckpro21 from '@/assets/deckpro (21).jpeg';
import deckpro22 from '@/assets/deckpro (22).jpeg';
import deckpro23 from '@/assets/deckpro (23).jpeg';
import deckpro24 from '@/assets/deckpro (24).jpeg';
import deckpro25 from '@/assets/deckpro (25).jpeg';
import deckpro26 from '@/assets/deckpro (26).jpeg';
import deckpro27 from '@/assets/deckpro (27).jpeg';
import deckpro28 from '@/assets/deckpro (28).jpeg';
import deckpro29 from '@/assets/deckpro (29).jpeg';
import deckpro30 from '@/assets/deckpro (30).jpeg';
import deckpro31 from '@/assets/deckpro (31).jpeg';
import deckpro32 from '@/assets/deckpro (32).jpeg';
import deckpro33 from '@/assets/deckpro (33).jpeg';
import deckpro34 from '@/assets/deckpro (34).jpeg';
import deckpro35 from '@/assets/deckpro (35).jpeg';
import deckpro36 from '@/assets/deckpro (36).jpeg';
import deckpro37 from '@/assets/deckpro (37).jpeg';
import deckpro38 from '@/assets/deckpro (38).jpeg';
import deckpro39 from '@/assets/deckpro (39).jpeg';
import deckpro40 from '@/assets/deckpro (40).jpeg';
import deckpro41 from '@/assets/deckpro (41).jpeg';
import deckpro42 from '@/assets/deckpro (42).jpeg';

const allImages = [
  deckpro1, deckpro2, deckpro3, deckpro4, deckpro5, deckpro6, deckpro7,
  deckpro8, deckpro9, deckpro10, deckpro11, deckpro12, deckpro13, deckpro14,
  deckpro15, deckpro16, deckpro17, deckpro18, deckpro19, deckpro20, deckpro21,
  deckpro22, deckpro23, deckpro24, deckpro25, deckpro26, deckpro27, deckpro28,
  deckpro29, deckpro30, deckpro31, deckpro32, deckpro33, deckpro34, deckpro35,
  deckpro36, deckpro37, deckpro38, deckpro39, deckpro40, deckpro41, deckpro42,
];

function getImages(index: number): string[] {
  return [
    allImages[(index * 4) % 42],
    allImages[(index * 4 + 1) % 42],
    allImages[(index * 4 + 2) % 42],
    allImages[(index * 4 + 3) % 42],
  ];
}

function getImageAlts(town: string): string[] {
  return [
    `Custom deck construction in ${town}, NJ`,
    `Deck repair project in ${town}, NJ`,
    `Composite decking installation in ${town}, NJ`,
    `Outdoor living space in ${town}, NJ`,
  ];
}

export interface TownEntry {
  town: string;
  county: string;
  countySlug: string;
  slug: string;
  description: string;
  images: string[];
  imageAlts: string[];
}

export const towns: TownEntry[] = [
  // Morris County
  {
    town: 'Morristown',
    county: 'Morris County',
    countySlug: 'morris-county',
    slug: 'morristown',
    description: 'Looking for a professional deck builder in Morristown, NJ? DeckPros NJ provides custom deck construction, repair, and replacement services to Morristown homeowners in Morris County. Licensed, insured, and backed by 25+ years of experience.',
    images: getImages(0),
    imageAlts: getImageAlts('Morristown'),
  },
  {
    town: 'Parsippany',
    county: 'Morris County',
    countySlug: 'morris-county',
    slug: 'parsippany',
    description: 'DeckPros NJ is the trusted deck contractor serving Parsippany, NJ and surrounding Morris County communities. From composite deck installation to wood deck repair, we deliver quality craftsmanship and reliable service for every project.',
    images: getImages(1),
    imageAlts: getImageAlts('Parsippany'),
  },
  {
    town: 'Denville',
    county: 'Morris County',
    countySlug: 'morris-county',
    slug: 'denville',
    description: 'Need a deck builder in Denville, NJ? DeckPros NJ specializes in deck construction, restoration, and replacement for Denville homes in Morris County. We handle everything from design to permitting to final inspection.',
    images: getImages(2),
    imageAlts: getImageAlts('Denville'),
  },
  {
    town: 'Randolph',
    county: 'Morris County',
    countySlug: 'morris-county',
    slug: 'randolph',
    description: 'As a leading deck contractor in Randolph, NJ, DeckPros NJ builds custom wood and composite decks for homeowners throughout Morris County. Our team brings decades of New Jersey deck construction experience to every Randolph project.',
    images: getImages(3),
    imageAlts: getImageAlts('Randolph'),
  },
  {
    town: 'Roxbury',
    county: 'Morris County',
    countySlug: 'morris-county',
    slug: 'roxbury',
    description: 'DeckPros NJ proudly serves Roxbury, NJ with professional deck building, repair, and replacement services. Roxbury homeowners in Morris County trust us for premium composite and wood decking solutions backed by expert craftsmanship.',
    images: getImages(4),
    imageAlts: getImageAlts('Roxbury'),
  },
  {
    town: 'Chester',
    county: 'Morris County',
    countySlug: 'morris-county',
    slug: 'chester',
    description: 'Searching for a reliable deck builder in Chester, NJ? DeckPros NJ offers complete deck construction and repair services to Chester residents in Morris County. We create beautiful outdoor spaces using premium materials and proven techniques.',
    images: getImages(5),
    imageAlts: getImageAlts('Chester'),
  },
  {
    town: 'Madison',
    county: 'Morris County',
    countySlug: 'morris-county',
    slug: 'madison',
    description: 'DeckPros NJ is your go-to deck contractor in Madison, NJ, providing custom deck design, construction, and restoration to Madison homeowners in Morris County. From PVC decking to traditional wood, we build decks that last.',
    images: getImages(6),
    imageAlts: getImageAlts('Madison'),
  },
  {
    town: 'Chatham',
    county: 'Morris County',
    countySlug: 'morris-county',
    slug: 'chatham',
    description: 'Chatham, NJ homeowners choose DeckPros NJ for expert deck construction, repair, and replacement in Morris County. Our licensed and insured team delivers high-quality composite and wood decking tailored to your property.',
    images: getImages(7),
    imageAlts: getImageAlts('Chatham'),
  },
  {
    town: 'Boonton',
    county: 'Morris County',
    countySlug: 'morris-county',
    slug: 'boonton',
    description: 'DeckPros NJ brings top-tier deck building services to Boonton, NJ and the greater Morris County area. Whether you need a new deck, a full replacement, or expert repairs, our experienced contractors deliver outstanding results.',
    images: getImages(8),
    imageAlts: getImageAlts('Boonton'),
  },
  {
    town: 'Dover',
    county: 'Morris County',
    countySlug: 'morris-county',
    slug: 'dover',
    description: 'Looking for affordable deck construction in Dover, NJ? DeckPros NJ serves Dover and all of Morris County with professional deck building, repair, and composite decking installation. Get a free estimate from our licensed team today.',
    images: getImages(9),
    imageAlts: getImageAlts('Dover'),
  },
  // Sussex County
  {
    town: 'Newton',
    county: 'Sussex County',
    countySlug: 'sussex-county',
    slug: 'newton',
    description: 'DeckPros NJ is the premier deck builder serving Newton, NJ and Sussex County. We specialize in custom deck construction, deck repair, and complete deck replacement using top-quality composite and wood materials.',
    images: getImages(10),
    imageAlts: getImageAlts('Newton'),
  },
  {
    town: 'Sparta',
    county: 'Sussex County',
    countySlug: 'sussex-county',
    slug: 'sparta',
    description: 'Sparta, NJ homeowners trust DeckPros NJ for professional deck construction and repair services in Sussex County. Our skilled contractors build stunning wood and composite decks designed for the New Jersey climate.',
    images: getImages(11),
    imageAlts: getImageAlts('Sparta'),
  },
  {
    town: 'Vernon',
    county: 'Sussex County',
    countySlug: 'sussex-county',
    slug: 'vernon',
    description: 'Need a deck contractor in Vernon, NJ? DeckPros NJ provides full-service deck construction, restoration, and replacement throughout Vernon and Sussex County. Licensed, insured, and committed to quality workmanship.',
    images: getImages(12),
    imageAlts: getImageAlts('Vernon'),
  },
  {
    town: 'Hopatcong',
    county: 'Sussex County',
    countySlug: 'sussex-county',
    slug: 'hopatcong',
    description: 'DeckPros NJ delivers expert deck building and repair services to Hopatcong, NJ residents in Sussex County. From lakeside composite decks to classic wood designs, we bring your outdoor vision to life with precision craftsmanship.',
    images: getImages(13),
    imageAlts: getImageAlts('Hopatcong'),
  },
  {
    town: 'Andover',
    county: 'Sussex County',
    countySlug: 'sussex-county',
    slug: 'andover',
    description: 'As a trusted deck builder in Andover, NJ, DeckPros NJ offers premium deck construction, repair, and replacement services across Sussex County. We use the best materials and techniques to ensure your deck stands the test of time.',
    images: getImages(14),
    imageAlts: getImageAlts('Andover'),
  },
  {
    town: 'Byram',
    county: 'Sussex County',
    countySlug: 'sussex-county',
    slug: 'byram',
    description: 'DeckPros NJ serves Byram, NJ with comprehensive deck construction and contractor services in Sussex County. Whether you want a new composite deck or need expert wood deck repairs, our team has you covered.',
    images: getImages(15),
    imageAlts: getImageAlts('Byram'),
  },
  {
    town: 'Frankford',
    county: 'Sussex County',
    countySlug: 'sussex-county',
    slug: 'frankford',
    description: 'Frankford, NJ homeowners rely on DeckPros NJ for dependable deck construction, repair, and replacement in Sussex County. Our New Jersey licensed contractors specialize in both composite and traditional wood decking solutions.',
    images: getImages(16),
    imageAlts: getImageAlts('Frankford'),
  },
  {
    town: 'Hampton',
    county: 'Sussex County',
    countySlug: 'sussex-county',
    slug: 'hampton',
    description: 'Choose DeckPros NJ as your deck builder in Hampton, NJ for quality deck construction and repair services in Sussex County. We design and build custom decks that enhance your home and withstand New Jersey weather year-round.',
    images: getImages(17),
    imageAlts: getImageAlts('Hampton'),
  },
  {
    town: 'Stillwater',
    county: 'Sussex County',
    countySlug: 'sussex-county',
    slug: 'stillwater',
    description: 'DeckPros NJ provides professional deck building, repair, and replacement services to Stillwater, NJ and surrounding Sussex County areas. From initial design through construction, we ensure a seamless experience for every homeowner.',
    images: getImages(18),
    imageAlts: getImageAlts('Stillwater'),
  },
  {
    town: 'Green',
    county: 'Sussex County',
    countySlug: 'sussex-county',
    slug: 'green',
    description: 'Looking for a deck contractor in Green Township, NJ? DeckPros NJ offers expert deck construction, composite decking, and wood deck repair throughout Green and Sussex County. Contact us for a free project estimate.',
    images: getImages(19),
    imageAlts: getImageAlts('Green'),
  },
  // Warren County
  {
    town: 'Belvidere',
    county: 'Warren County',
    countySlug: 'warren-county',
    slug: 'belvidere',
    description: 'DeckPros NJ is the trusted deck builder for Belvidere, NJ homeowners in Warren County. We deliver custom deck construction, professional repair, and full deck replacement with quality materials and skilled craftsmanship.',
    images: getImages(20),
    imageAlts: getImageAlts('Belvidere'),
  },
  {
    town: 'Hackettstown',
    county: 'Warren County',
    countySlug: 'warren-county',
    slug: 'hackettstown',
    description: 'Hackettstown, NJ residents trust DeckPros NJ for all their deck construction and repair needs in Warren County. Our licensed contractors build beautiful composite and wood decks designed to complement your New Jersey home.',
    images: getImages(21),
    imageAlts: getImageAlts('Hackettstown'),
  },
  {
    town: 'Phillipsburg',
    county: 'Warren County',
    countySlug: 'warren-county',
    slug: 'phillipsburg',
    description: 'Need a reliable deck builder in Phillipsburg, NJ? DeckPros NJ serves Phillipsburg and Warren County with expert deck construction, restoration, and replacement services. We handle permits, design, and build from start to finish.',
    images: getImages(22),
    imageAlts: getImageAlts('Phillipsburg'),
  },
  {
    town: 'Washington',
    county: 'Warren County',
    countySlug: 'warren-county',
    slug: 'washington',
    description: 'DeckPros NJ provides premium deck building and contractor services to Washington, NJ in Warren County. From new composite deck installations to wood deck repair, we bring over 25 years of New Jersey experience to your project.',
    images: getImages(23),
    imageAlts: getImageAlts('Washington'),
  },
  {
    town: 'Blairstown',
    county: 'Warren County',
    countySlug: 'warren-county',
    slug: 'blairstown',
    description: 'DeckPros NJ proudly serves Blairstown, NJ with professional deck construction, repair, and replacement in Warren County. Our expert deck contractors use premium materials to create durable outdoor living spaces for your home.',
    images: getImages(24),
    imageAlts: getImageAlts('Blairstown'),
  },
  {
    town: 'Knowlton',
    county: 'Warren County',
    countySlug: 'warren-county',
    slug: 'knowlton',
    description: 'Knowlton, NJ homeowners choose DeckPros NJ as their preferred deck builder in Warren County. We specialize in deck construction, composite decking installation, and expert wood deck repairs throughout the Knowlton area.',
    images: getImages(25),
    imageAlts: getImageAlts('Knowlton'),
  },
  {
    town: 'Oxford',
    county: 'Warren County',
    countySlug: 'warren-county',
    slug: 'oxford',
    description: 'Looking for deck construction services in Oxford, NJ? DeckPros NJ is a licensed deck contractor serving Oxford and Warren County with custom deck builds, repairs, and full replacements using top-grade composite and wood materials.',
    images: getImages(26),
    imageAlts: getImageAlts('Oxford'),
  },
  {
    town: 'Allamuchy',
    county: 'Warren County',
    countySlug: 'warren-county',
    slug: 'allamuchy',
    description: 'DeckPros NJ brings expert deck building services to Allamuchy, NJ in Warren County. Whether you need a brand-new deck, a complete replacement, or quality repairs, our licensed and insured team delivers results you can count on.',
    images: getImages(27),
    imageAlts: getImageAlts('Allamuchy'),
  },
  {
    town: 'Independence',
    county: 'Warren County',
    countySlug: 'warren-county',
    slug: 'independence',
    description: 'DeckPros NJ is the go-to deck contractor for Independence Township, NJ residents in Warren County. We offer complete deck construction, repair, and composite decking services with a commitment to quality and customer satisfaction.',
    images: getImages(28),
    imageAlts: getImageAlts('Independence'),
  },
  {
    town: 'Lopatcong',
    county: 'Warren County',
    countySlug: 'warren-county',
    slug: 'lopatcong',
    description: 'Serving Lopatcong, NJ and all of Warren County, DeckPros NJ is your local deck builder for custom construction, professional repairs, and deck replacement. Our New Jersey team delivers beautiful, long-lasting outdoor spaces.',
    images: getImages(29),
    imageAlts: getImageAlts('Lopatcong'),
  },
  // Hunterdon County
  {
    town: 'Flemington',
    county: 'Hunterdon County',
    countySlug: 'hunterdon-county',
    slug: 'flemington',
    description: 'DeckPros NJ is the leading deck builder in Flemington, NJ, providing custom deck construction, repair, and replacement to Hunterdon County homeowners. Our skilled contractors work with composite, PVC, and natural wood to craft your ideal outdoor space.',
    images: getImages(30),
    imageAlts: getImageAlts('Flemington'),
  },
  {
    town: 'Clinton',
    county: 'Hunterdon County',
    countySlug: 'hunterdon-county',
    slug: 'clinton',
    description: 'Clinton, NJ residents trust DeckPros NJ for expert deck construction and contractor services in Hunterdon County. From initial deck design to final build, we deliver premium craftsmanship and lasting quality for every project.',
    images: getImages(31),
    imageAlts: getImageAlts('Clinton'),
  },
  {
    town: 'Lambertville',
    county: 'Hunterdon County',
    countySlug: 'hunterdon-county',
    slug: 'lambertville',
    description: 'Need a professional deck builder in Lambertville, NJ? DeckPros NJ offers comprehensive deck construction, repair, and replacement services throughout Lambertville and Hunterdon County. Licensed, insured, and dedicated to excellence.',
    images: getImages(32),
    imageAlts: getImageAlts('Lambertville'),
  },
  {
    town: 'Raritan',
    county: 'Hunterdon County',
    countySlug: 'hunterdon-county',
    slug: 'raritan',
    description: 'DeckPros NJ serves Raritan Township, NJ with top-quality deck building, repair, and composite decking services in Hunterdon County. Our experienced New Jersey contractors create custom outdoor living solutions for every home.',
    images: getImages(33),
    imageAlts: getImageAlts('Raritan'),
  },
  {
    town: 'Readington',
    county: 'Hunterdon County',
    countySlug: 'hunterdon-county',
    slug: 'readington',
    description: 'Readington, NJ homeowners rely on DeckPros NJ for premium deck construction and repair in Hunterdon County. We build custom wood and composite decks that add value and beauty to your New Jersey property.',
    images: getImages(34),
    imageAlts: getImageAlts('Readington'),
  },
  {
    town: 'Tewksbury',
    county: 'Hunterdon County',
    countySlug: 'hunterdon-county',
    slug: 'tewksbury',
    description: 'As a respected deck contractor in Tewksbury, NJ, DeckPros NJ delivers expert deck construction, restoration, and replacement across Hunterdon County. Trust our licensed team for quality decking solutions built to last.',
    images: getImages(35),
    imageAlts: getImageAlts('Tewksbury'),
  },
  {
    town: 'Bethlehem',
    county: 'Hunterdon County',
    countySlug: 'hunterdon-county',
    slug: 'bethlehem',
    description: 'DeckPros NJ provides Bethlehem Township, NJ with professional deck building and repair services in Hunterdon County. From deck construction to complete replacement, our New Jersey contractors ensure superior quality on every project.',
    images: getImages(36),
    imageAlts: getImageAlts('Bethlehem'),
  },
  {
    town: 'Alexandria',
    county: 'Hunterdon County',
    countySlug: 'hunterdon-county',
    slug: 'alexandria',
    description: 'DeckPros NJ is the preferred deck builder for Alexandria Township, NJ homeowners in Hunterdon County. We offer custom deck construction, expert repair, and composite decking installation with attention to detail and lasting results.',
    images: getImages(37),
    imageAlts: getImageAlts('Alexandria'),
  },
  {
    town: 'Delaware',
    county: 'Hunterdon County',
    countySlug: 'hunterdon-county',
    slug: 'delaware',
    description: 'Searching for a deck contractor in Delaware Township, NJ? DeckPros NJ serves Delaware and Hunterdon County with full-service deck construction, repair, and wood and composite deck replacement for residential properties.',
    images: getImages(38),
    imageAlts: getImageAlts('Delaware'),
  },
  {
    town: 'Union',
    county: 'Hunterdon County',
    countySlug: 'hunterdon-county',
    slug: 'union',
    description: 'Union Township, NJ homeowners count on DeckPros NJ for reliable deck construction and repair in Hunterdon County. Our licensed New Jersey deck builders create beautiful custom decks using premium composite and wood materials.',
    images: getImages(39),
    imageAlts: getImageAlts('Union'),
  },
  // Somerset County
  {
    town: 'Somerville',
    county: 'Somerset County',
    countySlug: 'somerset-county',
    slug: 'somerville',
    description: 'DeckPros NJ is the top deck builder in Somerville, NJ, serving Somerset County homeowners with expert deck construction, repair, and replacement. We craft custom composite and wood decks that transform your outdoor living space.',
    images: getImages(40),
    imageAlts: getImageAlts('Somerville'),
  },
  {
    town: 'Bridgewater',
    county: 'Somerset County',
    countySlug: 'somerset-county',
    slug: 'bridgewater',
    description: 'Bridgewater, NJ residents choose DeckPros NJ as their trusted deck contractor in Somerset County. From new deck construction to professional repairs and composite decking, we deliver exceptional results backed by decades of experience.',
    images: getImages(41),
    imageAlts: getImageAlts('Bridgewater'),
  },
  {
    town: 'Bernardsville',
    county: 'Somerset County',
    countySlug: 'somerset-county',
    slug: 'bernardsville',
    description: 'Looking for a deck builder in Bernardsville, NJ? DeckPros NJ provides complete deck construction, repair, and replacement services to Bernardsville homeowners in Somerset County. Quality materials, expert installation, lasting results.',
    images: getImages(42),
    imageAlts: getImageAlts('Bernardsville'),
  },
  {
    town: 'Bound Brook',
    county: 'Somerset County',
    countySlug: 'somerset-county',
    slug: 'bound-brook',
    description: 'DeckPros NJ brings professional deck building and repair services to Bound Brook, NJ in Somerset County. Our licensed deck contractors specialize in wood and composite deck construction designed to enhance your New Jersey home.',
    images: getImages(43),
    imageAlts: getImageAlts('Bound Brook'),
  },
  {
    town: 'Franklin',
    county: 'Somerset County',
    countySlug: 'somerset-county',
    slug: 'franklin',
    description: 'Franklin Township, NJ homeowners trust DeckPros NJ for premium deck construction and contractor services in Somerset County. We build custom decks, handle full replacements, and provide expert repair for all decking materials.',
    images: getImages(44),
    imageAlts: getImageAlts('Franklin'),
  },
  {
    town: 'Hillsborough',
    county: 'Somerset County',
    countySlug: 'somerset-county',
    slug: 'hillsborough',
    description: 'DeckPros NJ is the go-to deck builder for Hillsborough, NJ, offering deck construction, repair, and composite decking installation throughout Somerset County. Our experienced New Jersey team delivers craftsmanship you can depend on.',
    images: getImages(45),
    imageAlts: getImageAlts('Hillsborough'),
  },
  {
    town: 'Warren',
    county: 'Somerset County',
    countySlug: 'somerset-county',
    slug: 'warren',
    description: 'Warren Township, NJ residents rely on DeckPros NJ for expert deck construction and repair in Somerset County. From custom wood decks to modern composite builds, our licensed contractors create outdoor spaces that exceed expectations.',
    images: getImages(46),
    imageAlts: getImageAlts('Warren'),
  },
  {
    town: 'Watchung',
    county: 'Somerset County',
    countySlug: 'somerset-county',
    slug: 'watchung',
    description: 'DeckPros NJ proudly serves Watchung, NJ with comprehensive deck building, repair, and replacement services in Somerset County. Contact our licensed New Jersey deck contractors for a free estimate on your custom deck project.',
    images: getImages(47),
    imageAlts: getImageAlts('Watchung'),
  },
  {
    town: 'Bedminster',
    county: 'Somerset County',
    countySlug: 'somerset-county',
    slug: 'bedminster',
    description: 'As a premier deck contractor in Bedminster, NJ, DeckPros NJ offers custom deck construction, repair, and replacement throughout Somerset County. We use top-quality composite and wood materials for decks built to last.',
    images: getImages(48),
    imageAlts: getImageAlts('Bedminster'),
  },
  {
    town: 'Branchburg',
    county: 'Somerset County',
    countySlug: 'somerset-county',
    slug: 'branchburg',
    description: 'Branchburg, NJ homeowners choose DeckPros NJ for reliable deck construction, repair, and composite decking in Somerset County. Our skilled New Jersey deck builders deliver outstanding quality and personalized service on every project.',
    images: getImages(49),
    imageAlts: getImageAlts('Branchburg'),
  },
];
